// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/17b958b654185f62f554.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"2714856f84a44f22fe06","170":"5dc3df95dbd29b35c49f","171":"28c09aa919079f7e4f28"}[chunkId] + ".chunk.js";
};